export interface GranulometryLimits {
    d80: { min: number; max: number };
    d50: { min: number; max: number };
    d20: { min: number; max: number };
}

export interface GranulometryAlert {
    truckId: string;
    plate: string;
    detectionDate: Date;
    alertType: 'D80' | 'D50' | 'D20' | 'MULTIPLE';
    message: string;
    severity: 'warning' | 'critical';
    acknowledged: boolean;
}

export const DEFAULT_GRANULOMETRY_LIMITS: GranulometryLimits = {
    d80: { min: 100, max: 200 },  // mm
    d50: { min: 50, max: 100 },   // mm
    d20: { min: 20, max: 40 }     // mm
};
